import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const LoadingSpinner = ({ size = 'large', tip = 'Loading...' }) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '200px',
      padding: '20px'
    }}>
      <Spin 
        indicator={antIcon} 
        size={size} 
        tip={tip}
        style={{ fontSize: size === 'small' ? 16 : size === 'large' ? 32 : 24 }}
      />
    </div>
  );
};

export default LoadingSpinner;